import { Component, signal } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-no-federation',
  standalone: false,
  template: `
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
      <div class="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md">

        <div class="text-center mb-8">
          <h1 class="text-2xl font-bold text-gray-800">SportIQ Finances</h1>
          <p class="mt-2 text-gray-500 text-sm">Entrez le code de votre fédération pour accéder à votre espace</p>
        </div>

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Code fédération</label>
          <input
            type="text"
            [(ngModel)]="federationCode"
            (ngModelChange)="onCodeChange()"
            placeholder="Ex : FRMTT, FRTV, FRHN..."
            class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent uppercase tracking-widest"
            maxlength="20"
            (keydown.enter)="redirect()"
          />
          @if (error()) {
            <p class="mt-1 text-xs text-red-500">{{ error() }}</p>
          }
        </div>

        <div class="mt-6">
          <button
            (click)="redirect()"
            class="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2.5 rounded-lg transition-colors"
          >
            Accéder à mon espace
          </button>
        </div>

        <p class="mt-6 text-center text-xs text-gray-400">
          Contactez votre fédération si vous ne connaissez pas votre code.
        </p>
      </div>
    </div>
  `,
})
export class NoFederationComponent {
  federationCode = '';
  error = signal<string | null>(null);

  onCodeChange(): void {
    this.error.set(null);
  }

  redirect(): void {
    const code = this.federationCode.trim().toLowerCase();

    if (!code) {
      this.error.set('Veuillez saisir le code de votre fédération.');
      return;
    }

    if (!/^[a-z0-9-]+$/.test(code)) {
      this.error.set('Code invalide. Utilisez uniquement des lettres et des chiffres.');
      return;
    }

    const { protocol } = window.location;
    const baseDomain = (environment as any).baseDomain;
    window.location.href = `${protocol}//${code}.${baseDomain}/federation/auth/login`;
  }
}
